import { Link, Redirect } from "react-router-dom";
import React, { useState, useEffect } from "react";
import {
  createSubscriptionCheckoutSessionWithTrial,
  topOffCredits,
} from "../audiblogsApi";
import queryString from "query-string";
import { observer } from "mobx-react";
import mixpanel from "mixpanel-browser";
import loadingIcon from "../Assets/loading.gif";
import userStore from "../Stores/User";
import { loadStripe } from "@stripe/stripe-js";

const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;
const stripePromise = loadStripe(STRIPE_API_KEY);

const Subscribe = observer((props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [quantity, setQuantity] = useState(25);
  const params = queryString.parse(props.location.search);
  const [sessionId, setSessionId] = useState(null);
  const [paymentIssue, setPaymentIssue] = useState(false);
  const { idToken, voiceQuality, isUserPaying } = userStore;

  const [redirectTo, setRedirectTo] = useState("");

  const redirectToCheckout = () => {
    stripePromise.then((stripe) => {
      stripe
        .redirectToCheckout({
          sessionId,
        })
        .then((handleResult) => {
          console.log("handle results");
          handleResult();
        })
        .catch((e) => {
          console.log(e);
        });
    });
  };

  useEffect(() => {
    if (idToken) {
      // Get Stripe Checkout Session Id
      createSubscriptionCheckoutSessionWithTrial(false, idToken)
        .then(function (data) {
          setSessionId(data.data.sessionId);
        })
        .catch((e) => {
          console.log(e);
          // alert("Something went wrong. Please try again or contact us.");
        });
    }
  }, [idToken]);

  function roundToX(num, X) {
    return +(Math.round(num + "e+" + X) + "e-" + X);
  }

  useEffect(() => {
    mixpanel.track(`Open Pricing Page (Onboarding)`);
  }, []);

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }
  return (
    <div className="center-static">
      {isUserPaying ? (
        <div>
          <h1 className="headline" style={{ margin: "0" }}>
            Buy {voiceQuality === "hd" ? "HD" : "SD"} Credits
          </h1>
          <input
            style={{ margin: "35px", width: "300px" }}
            type="range"
            min="5"
            step="5"
            value={quantity}
            max="50"
            onChange={(e) => {
              setQuantity(e.target.value);
            }}
          ></input>
          <h1 className="subheadline" style={{ margin: "0" }}>
            {quantity} hours{" "}
          </h1>
          {paymentIssue && (
            <div>
              Issues?{" "}
              <a href={userStore.customerPortalUrl} target="_blank">
                Add a payment method
              </a>{" "}
              and try again.
            </div>
          )}

          <div className="cta-div" style={{ position: "static" }}>
            <a
              className="cta-button"
              onClick={(e) => {
                e.preventDefault();
                e.target.innerHTML = "Loading...";
                mixpanel.track("Top off credits");
                topOffCredits(idToken, quantity, voiceQuality).then((res) => {
                  console.log(res.data);
                  const userIsCharged = res.data.is_user_charged;
                  console.log(userIsCharged);
                  if (userIsCharged === true) {
                    userStore.updateUser();
                    e.target.innerHTML = "Done!";
                    setRedirectTo("/");
                  } else {
                    setPaymentIssue(true);
                    e.target.innerHTML = "Something's wrong";
                  }
                });
              }}
              style={{ width: "auto" }}
            >
              Confirm $
              {voiceQuality === "hd"
                ? roundToX((quantity / 5) * 4.99, 2)
                : roundToX((quantity / 5) * 1.99, 2)}
            </a>

            <Link to="/add" className="sub-cta-link">
              Cancel
            </Link>
          </div>
        </div>
      ) : (
        <div>
          {" "}
          <h1 className="headline" style={{ margin: "0" }}>
            Unlimited Plan
          </h1>
          <h2 className="subheadline">
            <span style={{ color: "rgb(255 143 65)", fontWeight: "bold" }}>
              Easy to cancel anytime
            </span>
            <br></br>
            $4.99/mo
          </h2>
          <div className="features" style={{ margin: "15px auto", maxWidth: '380px' }}>
            <div>👏 Up to 1.5 hours per article</div>
            <div>👏 100,000 characters per day</div>
            <div>
              👏 Supports English, Spanish, Arabic, Chinese, Danish, Dutch,
              French, German, Hindi, Italian, Japanese, Korean, Polish,
              Portuguese, Romanian, Russian, Swedish, Turkish
            </div>
          </div>
          <div className="cta-div" style={{ position: "static" }}>
            {sessionId ? (
              <a
                className="cta-button"
                style={{ width: "auto" }}
                onClick={(e) => {
                  e.preventDefault();
                  mixpanel.track("Click Go to Checkout");
                  redirectToCheckout();
                }}
              >
                Go to Checkout
              </a>
            ) : (
              <img
                src={loadingIcon}
                style={{ height: "50px" }}
                alt="loading..."
              />
            )}
            <Link to="/add" className="sub-cta-link">
              Cancel
            </Link>
          </div>
        </div>
      )}
    </div>
  );
});

export default Subscribe;
